import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { O365AuthService } from '../services/o365-auth.service';
import { filter, map, take } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { environment } from '../../environments/environment';

// export function roleGuard(requiredRoles: string[]): CanActivateFn {
//   return (route, state) => {
//     const authService = inject(O365AuthService);
//     const router = inject(Router);
//     const userRoles = authService.userroles;

//     console.debug('roleGuard {}', route.url);
//     console.debug("roleGuard", authService.username)
//     console.debug('roleGuard', route.toString());
//     console.debug('roleGuard', requiredRoles);
//     console.debug('roleGuard', userRoles);

//     if (!userRoles || userRoles.length === 0) {
//       router.navigate(['/access-denied']);
//     }
//     const hasAccess = requiredRoles.some(role => userRoles.includes(role));
//     if (!hasAccess) {
//       router.navigate(['/access-denied']);
//     }
//     return hasAccess;
//   };
// }

export function roleGuard(requiredRoles: string[]): CanActivateFn {
  return (route, state) => {
    const authService = inject(O365AuthService);
    const router = inject(Router);

    // I have to wait for my authService to be initialized
    return authService.isInitialized$.pipe(
      filter(init => init),
      take(1),
      map(() => {
        const userRoles = authService.userRoles();

        if (!userRoles || userRoles.length === 0) {
          router.navigate(['/access-denied']);
          return false;
        }

        const hasAccess = requiredRoles.some(role => userRoles.includes(role));

        if (!hasAccess) {
          router.navigate(['/access-denied']);
        }

        return hasAccess;
      })
    );
  };
}
